
export type MessagingGetChatRoomById200BasicInfoAllOfTwoType = typeof MessagingGetChatRoomById200BasicInfoAllOfTwoType[keyof typeof MessagingGetChatRoomById200BasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessagingGetChatRoomById200BasicInfoAllOfTwoType = {
  DIRECT: 'DIRECT',
  GROUP: 'GROUP',
} as const;
